import { useNavigate } from 'react-router'
import React from 'react'
import { groupEventsByContext } from 'src/mentor/components/MentorEventsPage/components/utils'
import { MentorEventSummaryComponent } from 'src/mentor/components/MentorEventsPage/MentorEventsComponentsAndHelpers'
import {
  BookedEventTitle,
  EventsPageMainItemsContainer,
  NewEventTypeButton,
} from 'src/mentor/components/MentorEventsPage/MentorEventsPageStyles'

export default function TherapistEventsListing({
  mentorEventTypes,
  associatedClinics,
  mentorSlug,
  onClickNewEventType,
  onClickExistingEventType,
  disableEventCreation = false,
}) {
  const navigate = useNavigate()
  const groupedEvents = groupEventsByContext(mentorEventTypes)

  const handleCopyEventLink = (e, item) => {
    // navigator.clipboard.writeText(item?.shortLink);      // will interfere with mobile app
    navigator.clipboard.writeText(
      `${window.location.origin}/mentor/${mentorSlug}/events/${item?.uid}`,
    )
    e.stopPropagation()
  }

  const handleOpenBookingPage = (e, item) => {
    navigate(`/mentor/${mentorSlug}/events/${item?.uid}`)
  }

  return (
    <>
      <>
        {(!Boolean(mentorEventTypes) || mentorEventTypes?.length === 0) && (
          <BookedEventTitle style={{ margin: '20px' }}>
            You don&apos;t have any events. {disableEventCreation && 'Make your first event now.'}
          </BookedEventTitle>
        )}
        {!disableEventCreation && (
          <div style={{ margin: '20px' }}>
            Tip: You can create 1 free public event to allow people to book a discovery call with
            you.
          </div>
        )}
        {!disableEventCreation && (
          <NewEventTypeButton
            style={{ marginTop: '20px', marginLeft: '20px' }}
            onClick={() => onClickNewEventType(true)}
          >
            + New Event Type
          </NewEventTypeButton>
        )}
      </>
      {Object.keys(groupedEvents).map((contextId) => (
        <div key={contextId}>
          <div style={{ padding: '24px 24px 0' }}>
            {contextId === 'default'
              ? 'Personal Events (Not offered in clinics):'
              : `Events offered in ${
                  associatedClinics?.find((item) => item?.id === contextId)?.firstName
                }:`}
          </div>
          <EventsPageMainItemsContainer>
            {groupedEvents[contextId].map((item, index) => (
              <MentorEventSummaryComponent
                key={item.uid}
                item={item}
                onClickEvent={() => {
                  onClickExistingEventType(item)
                }}
                handleCopyEventLink={handleCopyEventLink}
                handleOpenBookingPage={handleOpenBookingPage}
              />
            ))}
          </EventsPageMainItemsContainer>
        </div>
      ))}
    </>
  )
}
